// services/companyService.js
// Superadmin-only endpoints for viewing/managing companies (customers) on 6ELA.
// Assumes a backend route like: GET /api/superadmin/companies -> Company.findAll({ include: [owner, lbaForms] })
// Adjust BASE_URL / auth header wiring to match your existing services (e.g. debtorDetailsService).

import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL || "";

const authHeaders = () => {
  const token = localStorage.getItem("authToken");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const companyService = {
  // Returns all companies with owner + lbaForms count included
  getAllCompanies: async () => {
    const res = await axios.get(`${BASE_URL}/api/superadmin/companies`, {
      headers: authHeaders(),
    });
    return res.data;
  },

  // Toggle suspend/unsuspend
  setSuspended: async (companyId, isSuspended, suspensionReason = "") => {
    const res = await axios.patch(
      `${BASE_URL}/api/superadmin/companies/${companyId}/suspend`,
      { isSuspended, suspensionReason },
      { headers: authHeaders() }
    );
    return res.data;
  },

  getCompanyById: async (companyId) => {
    const res = await axios.get(
      `${BASE_URL}/api/superadmin/companies/${companyId}`,
      { headers: authHeaders() }
    );
    return res.data;
  },

  // Toggle a company's platform fee flag (default: disabled)
  setPlatformFeeEnabled: async (companyId, platformFeeEnabled) => {
    const res = await axios.patch(
      `${BASE_URL}/api/superadmin/companies/${companyId}/platform-fee`,
      { platformFeeEnabled },
      { headers: authHeaders() }
    );
    return res.data;
  },
};